angular.module('zc.projects')

.directive 'zcBreadcrumbSelector', (ProjectBreadcrumb, Meta, BaseProjectCrudEditor) ->

  class Breadcrumb extends BaseProjectCrudEditor
    link: (scope, element, attrs) ->
      # only this specific functionality
      scope.page_types = ["item", "category"]

  editor = new Breadcrumb(
    ProjectBreadcrumb
    Meta
    '/templates/projects.settings/other/breadcrumb_selector.html'
  )

  return editor.createDirective()



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/other/breadcrumb_selector.directive.coffee